module.exports = __webpack_public_path__ + "2acb60f2/img/archive-icon.0a6a9de3.svg";